import { Identifiable, CalendarHolidays, Resource } from "@planzone/dto";
import { LinkedResource, Linker } from "../linkers/types";
import { HttpClient, HttpMethods } from "../types/httpClient";

function assignPersonalCalendarHolidays(
  httpClient: HttpClient,
  linker: Linker,
) {
  return (
    resource: Identifiable<Resource>,
    calendarHolidays: Identifiable<CalendarHolidays>,
  ) =>
    httpClient
      .sendHttpRequest<LinkedResource<Identifiable<Resource>>>({
        endpoint: `/resources/${resource.uuid}`,
        method: HttpMethods.PATCH,
        data: {
          calendarHolidays: `calendarHolidayses/${calendarHolidays.uuid}`,
        },
      })
      .then(linker.linkResource)
      .then((resource) => ({ ...resource, calendarHolidays }));
}

export { assignPersonalCalendarHolidays };
